import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddFloor, EditFloor, FloorParams, FloorWithPage } from '@app/interfaces/rm/location-floor';
import { SelectOption } from '@app/interfaces/sys/dict';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocationFloorService {
    private baseUrl = environment.api.services.rm + '/location-floors';

    constructor(private http: HttpClient) {
    }

    async find(params: FloorParams): Promise<FloorWithPage> {
        return lastValueFrom(this.http.get<FloorWithPage>(`${this.baseUrl}`, {
            params: Object.assign(params),
        }));
    }

    async options(params?: { locationLabId: number, name?: string }): Promise<SelectOption[]> {
        return lastValueFrom(this.http.get<SelectOption[]>(`${this.baseUrl}/all-options`, {
            params: params ? Object.assign(params) : {}
        }));
    }


    async add(params: AddFloor): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}`, params));
    }

    async edit(data: EditFloor): Promise<void> {
        return lastValueFrom(this.http.put<void>(`${this.baseUrl}`, data));
    }

    async remove(id: number): Promise<void> {
        return lastValueFrom(this.http.delete<void>(`${this.baseUrl}`, {
            params: Object.assign({ id }),
        }))
    }
}
